import { makeAutoObservable } from 'mobx';
import { ProcessStep } from '../../models/SuperThemProcess';
import { SuperThemProcessApi } from '../../apis/SuperThemProcess';

export class SuperThemProcessManagementPageModel {
  processSteps: ProcessStep[] = [];
  loading = false;
  isModalVisible = false;
  editingStep: ProcessStep | null = null;
  isEditMode = false;

  constructor() {
    makeAutoObservable(this);
  }

  async loadProcessSteps() {
    this.loading = true;
    try {
      const steps = await SuperThemProcessApi.getAllProcessSteps();
      this.processSteps = steps.sort((a: ProcessStep, b: ProcessStep) => a.order - b.order);
    } catch (error) {
      console.error('加载流程步骤失败:', error);
    } finally {
      this.loading = false;
    }
  }

  showAddModal() {
    this.isEditMode = false;
    this.editingStep = {
      id: '',
      type: 'agree',
      title: '',
      content: '',
      requiredText: '',
      order: this.processSteps.length + 1,
      confirmButtonText: '',
      cancelButtonText: ''
    };
    this.isModalVisible = true;
  }

  showEditModal(step: ProcessStep) {
    this.isEditMode = true;
    this.editingStep = { ...step };
    this.isModalVisible = true;
  }

  hideModal() {
    this.isModalVisible = false;
    this.editingStep = null;
    this.isEditMode = false;
  }

  async saveProcessStep() {
    if (!this.editingStep) return;

    try {
      if (this.isEditMode) {
        // 编辑模式 - 更新现有步骤
        const index = this.processSteps.findIndex(s => s.id === this.editingStep!.id);
        if (index !== -1) {
          this.processSteps[index] = { ...this.editingStep };
          this.processSteps.sort((a: ProcessStep, b: ProcessStep) => a.order - b.order);
        }
      } else {
        // 新增模式 - 添加新步骤
        const newId = await SuperThemProcessApi.addProcessStep(this.editingStep);
        const newStep = { ...this.editingStep, id: newId.toString() };
        this.processSteps.push(newStep);
        this.processSteps.sort((a: ProcessStep, b: ProcessStep) => a.order - b.order);
      }
      this.hideModal();
    } catch (error) {
      console.error('保存流程步骤失败:', error);
    }
  }

  async removeProcessStep(id: string) {
    try {
      const success = await SuperThemProcessApi.deleteProcessStep(id);
      if (success) {
        this.processSteps = this.processSteps.filter(s => s.id !== id);
        // 重新排序
        this.processSteps.forEach((step, index) => {
          step.order = index + 1;
        });
      }
    } catch (error) {
      console.error('删除流程步骤失败:', error);
    }
  }

  updateEditingStep(field: keyof ProcessStep, value: any) {
    if (this.editingStep) {
      (this.editingStep as any)[field] = value;
    }
  }
} 